import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InterviewSliceState } from "../../types/store";
import { Family } from "../../types/families";
import { CareGiver } from "../../types/caregivers";
import { IExecuteCompatibilityCalculationPayload } from "../../types/cloudFunctions";
import { Calculation } from "../../types/calculation";

export const INTERVIEW_SLICE = 'interview' as const;

const initialState: InterviewSliceState = {
  caregiver: null,
  family: null,
  calculationInProgress: false,
  calculationResult: null,
  distanceFromFamily: undefined,
}

export const interviewSlice = createSlice({
  name: INTERVIEW_SLICE,
  initialState: initialState,
  reducers: {
    loadInterviewFamily: (
      state: InterviewSliceState,
      { payload: family }: PayloadAction<Family | null>
    ) => {
      state.family = family;
    },
    loadInterviewCareGiver: (
      state: InterviewSliceState,
      { payload: caregiver }: PayloadAction<CareGiver | null>
    ) => {
      state.caregiver = caregiver;
    },
    calculateCompatibility: (
      state: InterviewSliceState,
      { payload: _ }: PayloadAction<IExecuteCompatibilityCalculationPayload>
    ) => {
      state.calculationInProgress = true;
    },
    calculateCompatibilitySuccess: (
      state: InterviewSliceState,
      { payload: result }: PayloadAction<Calculation>
    ) => {
      state.calculationInProgress = false;
      state.calculationResult = result;
    },
    calculateCompatibilityError: (
      state: InterviewSliceState,
      { payload: err }: PayloadAction<any> 
    ) => {
      state.calculationInProgress = false;
    },
    resetCompatibility: (
      state: InterviewSliceState,
      { payload: _ }: PayloadAction<undefined>
    ) => {
      state.calculationInProgress = false;
      state.calculationResult = null;
    },

    resetInterviewPage: (
      state: InterviewSliceState,
      {payload: _}: PayloadAction<undefined>
    ) => {
      state.calculationInProgress = false;
      state.calculationResult = null;
      state.caregiver = null;
      state.family = null;
      state.distanceFromFamily = undefined;
    },
    updateDistanceFromFamily: (
      state: InterviewSliceState,
      { payload: dff }: PayloadAction<string | undefined>
    ) => {
      state.distanceFromFamily = dff;
    }
  }
});

export const {
  loadInterviewCareGiver,
  loadInterviewFamily,
  calculateCompatibility,
  calculateCompatibilityError,
  calculateCompatibilitySuccess,
  resetInterviewPage,
  updateDistanceFromFamily,
} = interviewSlice.actions;

export default interviewSlice.reducer;